"use strict";
import imsrc from "../imsr-common.js";
import { ImsrApi } from "./imsrApi.js";

export class ImsrProjects {
  constructor() {
    this.imsrApi = new ImsrApi();
  }

  async getProject(tenantId, projectId) {
    try {
      const params = {
        tenantId: tenantId,
        projectId: projectId,
      };
      const res = await this.imsrApi.doApi("get", "/projects", params);
      return {
        tenantId: res.tenantId,
        projectId: res.projectId,
        projectName: res.projectName,
        projectOwner: res.projectOwner,
        secondaryUse: res.secondaryUse,
        allowedEmailDomains: res.allowedEmailDomains,
        isEnableChackEmailDomain: res.isEnableChackEmailDomain,
        lang: res.lang,
        zoneinfo: res.zoneinfo,
      };
    } catch (e) {
      throw { status: e.status, message: e.message };
    }
  }

  async getProjectMember(tenantId, projectId) {
    try {
      let members = [];
      const params = {
        tenantId: tenantId,
        projectId: projectId,
      };
      const res = await this.imsrApi.doApi("get", "/projects/member", params);
      res.forEach((item) => {
        members.push({
          userId: item.userId,
          userName: item.userName,
          userRole: item.userRole,
          mfa: item.mfa,
          updated_at: imsrc.dateFormat(item.updated_at),
          status: item.status,
        });
      });
      return members;
    } catch (e) {
      throw { status: e.status, message: e.message };
    }
  }

  async createProject(params) {
    return await this.imsrApi.doApi("post", "/projects", params);
  }
}

export default ImsrProjects;
